import { ColumnDef } from "@tanstack/react-table";
import { LineClampedTooltip } from "@/core/components/line-clamped-tooltip";
import type { IcmLineItem } from "@/icm/types";

const BusinessUnitCol = (): ColumnDef<IcmLineItem> => ({
  accessorKey: "business_unit_name",
  header: "Business Unit",
  meta: { size: "160px" },
  cell: ({ getValue }) => {
    const value = (getValue() as string | null) ?? "-";
    return (
      <LineClampedTooltip className="break-words">{value}</LineClampedTooltip>
    );
  },
});

export default BusinessUnitCol;
